const dailyFlowers = [
  {
    id: 'marigold-orange',
    title: 'Fresh Marigold (Orange)',
    alt: 'Fresh Marigold',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDvwkOlkrqf9ahhKQwDNjef1iNAZfIKl-MNcWBAQL4R2MNYpQpV9jCl6DbZW2Zt4eCPL6UzOxuOP2QBE2-sTpALQAAyeHnlBwLvThHGtpseprcolEreLxkw97st4rB_RkzGUg5cntPOu8ZjSMStYYnlhXhznCHuyd0b3oz81uWXTztaTU9WYeYWVJxLjKvH_KrqS9rnaVxzfzWPuGE8l4OXOSm3RMg34hPBimbWme2cdI3tpnewlOGd36cXl6Ea0q1HefEEUol0fzzn',
    oldPrice: '₹800',
    price: '₹650',
    unit: 'per kg',
    badge: '18% OFF'
  },
  {
    id: 'scented-jasmine',
    title: 'Scented Jasmine Buds',
    alt: 'White Jasmine',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBqFoN0Q4dIZyVcowJ77QYwTbxAbvsFCLTgk8ROQw9143-wg3NqbYUNUws38TOyj_KOM2J0rZwXtA95368wXggLbllW574HCSk4m0x9wAyIts_U2mCqJhIrnf7120MxIroJNzf0c3YDKfy9BSMt59t13WYU3yIlCvuYzdKMweHlKW3EHCdEAtbmdp0TYB8PcsKuhS-T5CLo8c1LvmW3CH-J6aBuOYC5MAFNScnGIgX-8sDb0TEzuTySax9tYFmwcQQr_oMrF_t2O7a_',
    oldPrice: '₹500',
    price: '₹400',
    unit: 'per 250g',
    badge: '20% OFF'
  },
  {
    id: 'red-rose-petals',
    title: 'Red Rose Petals',
    alt: 'Red Rose Petals',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAAxdumpMUmqZg03AEiXpb1iFBDasumBEyokQikrcIBeXTnuoCnWu0SpFZqDKJ44KoVG4IXdsx3-MQpnyfJjnDIlizgm72KrvVsfrZFnirtIQYH-6Hbw-4AzxUCCXoQvQRAwmwxRJPzDZWCZBeovoEIfdVKyp3Jp5gr2jcWMjTYyvC-S6e2fvN7GCdya2OX0hEhY_bSO8kxnAq9OkatR_mUnn2GFiw8a-cCBAjHYUpThuM1w6Gx532QraLZlEzCoQ9coGuWCKR8s3ro',
    oldPrice: '₹1,100',
    price: '₹935',
    unit: 'per kg',
    badge: '15% OFF'
  },
  {
    id: 'sacred-pink-lotus',
    title: 'Sacred Pink Lotus',
    alt: 'Sacred Pink Lotus',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDlkOcuvaCEnUjLOtaZVa07aXctYQTrus_gE6jIyrt0aYEgnIXKgobb9bR7fgEpzeiT-YCPl_VU5qSsfgnqOhdTkTNpn9QAEIQLWR0l-7haT8SXTs9OF1kpZ39RcedIl6se46zl5lF-p6A-SYdFinceUV_BvzoZuDcaPTVPkIObGP5NcCF9BZCny07j462WhdgS_TJB2GmxhhG8xxkqFjsjuJqdyIb49MiKdb0u-aD0anhj9EmPm6UHbpW1g3pw886Dh3_GZnAcVYgq',
    oldPrice: '₹100',
    price: '₹90',
    unit: 'per piece',
    badge: '10% OFF'
  },
  {
    id: 'yellow-sevanthi',
    title: 'Yellow Sevanthi',
    alt: 'Yellow Sevanthi',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA1qICqM-Pj4N7xxxUNbfhJ5PRtdAg4Lgzias5Lj0TZIol1YOUfOZ3Ks-fRMvjH5JMQSLCSZi3LRO-IFWHxO3VliZvf2usDB2C3d3RjEYgZ68BfuPBkvuN5y2lhRZfaexFyugo20Zo7jgjUb55jmN_37Mk-f4Kr9S6-spGnD0zYheMrRP6-E47xrepwVJjpVj067YFolRLK598tyyD5l5u9k9VEcizdq6O2zpSByxInojdSZPE3b0FBSN23v7C1v9hf9NWEoIrOBeSp',
    oldPrice: '₹1,200',
    price: '₹900',
    unit: 'per kg',
    badge: '25% OFF'
  }
];

export default dailyFlowers;
